import React, {useCallback} from 'react';
import PropTypes from 'prop-types';

import IssueAttachment from './IssueAttachment';
import {fetchAttachmentsAction} from '../../app/actions';
import {connect} from '../../app/connect';
import {getHasMoreAttachments, getIsLoadingAttachments, getUploadingAndExistingAttachments} from '../../app/selectors';
import InfiniteTransitionList from '../common/InfiniteTransitionList';

const IssueAttachmentsList = ({issueId, attachments, container, hasMore, isLoading, dispatch}) => {
  const loadMore = useCallback(() => {
    dispatch(fetchAttachmentsAction({issueId, offset: attachments.length}));
  }, [dispatch, attachments.length, issueId]);

  if (!attachments?.length) {
    return null;
  }

  return (
    <div className="IssueAttachmentsList">
      <InfiniteTransitionList
        exitTimeout={480}
        container={container}
        className="IssueAttachmentList"
        loaderClassName="IssueAttachmentsList__loader"
        isLoading={isLoading}
        hasMore={hasMore}
        loadMore={loadMore}
      >
        {attachments.map(attachment => (
          <IssueAttachment
            key={attachment.fileId || attachment.id || attachment.clientId}
            attachment={attachment}
            container={container}
          />
        ))}
      </InfiniteTransitionList>
    </div>
  );
};

IssueAttachmentsList.displayName = 'IssueAttachmentsList';

IssueAttachmentsList.propTypes = {
  issueId: PropTypes.string.isRequired,
  attachments: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  hasMore: PropTypes.bool.isRequired,
  container: PropTypes.object,
  dispatch: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  attachments: getUploadingAndExistingAttachments(state),
  isLoading: getIsLoadingAttachments(state),
  hasMore: getHasMoreAttachments(state)
});

export default connect(mapStateToProps)(IssueAttachmentsList);
